<!-- Componente de Cambio de contraseña -->

<template>
  <div class="passChange" v-if="ct!=0">
    
    <div class="conflex" style="justify-content:center">
      <v-sheet :elevation="4" style="width:500px">

        <!-- Cabecera -->
        <div class="cabecera">     
          <baseHeader           
            :cfg="$cfe.headers.mto"
            titulo="Cambio de Contraseña"
            @onEvent="eventHeader"> 
          </baseHeader>
        </div>

     
        <!-- Contenido -->
        <div class="contenedor">
          
          <div class="columna" style="padding-top:10px">
            <v-text-field            
              v-bind="$input"
              v-model="$store.state.G.USUARIO"
              label="Usuario"
              readonly>            
            </v-text-field>

            <v-text-field            
              v-bind="$input"
              v-model="ct.actualPass[2]"
              :label="ct.actualPass[1]"
              :type="show1 ? 'text' : 'password'"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show1 = !show1">            
            </v-text-field>

            <v-text-field            
              v-bind="$input"
              v-model="ct.newPass1[2]"
              :label="ct.newPass1[1]"
              :type="show2 ? 'text' : 'password'"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show2 = !show2">           
            </v-text-field>

            <v-text-field            
              v-bind="$input"
              v-model="ct.newPass2[2]"
              :label="ct.newPass2[1]"
              :type="show3 ? 'text' : 'password'"
              :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show3 = !show3">            
            </v-text-field>

            <!-- Botones Mto -->
            <baseBtraExtra class="conflex" style="padding:10px;justify-content:center"
              :modulo="btExtCfg"
              @onEvent="execAccion">
            </baseBtraExtra>

            <span style="color:red;padding-top:10px"> Recuerda que la contraseña no debe contener el mismo nombre que el 
              login ó usuario, al menos tiene que tener una longitud de 6 caracteres alfanuméricos y 
              tampoco puede repetir la contraseña actual</span>
          </div>        
        </div>
      </v-sheet>
    </div>
  </div>
</template>



<script>
  import { mixinM } from "@/mixins/mixinM.js";
  import plugs from "@/common/general_plugs";
  const baseHeader = () => plugs.groute("baseHeader.vue", "base");
  const baseBtraExtra = () => plugs.groute("baseBtraExtra.vue", "base");

  export default {
    mixins: [mixinM],
    components: { baseHeader, baseBtraExtra },
    props: {
      
      
      
    },

    data() {
      return {          
        stIni: {
          api: "passChange",
          name: "passChange" // raiz + ciacM + (index si NO tiene raiz)
        },

        // 
        btExtCfg:JSON.parse(JSON.stringify(this.$cfe.btra.EXTRA)),

        // no cargo el schema del store y se definen en esta variable
        schCtrls:{
          actualPass:["actualPass", "Contraseña Actual", ""],
          newPass1:["newPass1", "Nueva Contraseña", ""],
          newPass2:["newPass2", "Repite Contraseña", ""],
        },

        show1:false,
        show2:false,
        show3:false        
      };
    },

   
    methods: {
      async iniDataParticular() {
        console.log("DEV " + this.stIni.api + " ********************** (iniDataParticular)");
      
        // pongo a null el sch para que no cargue del servidor el schema         
        this.apiArgs.sch= null;

        // controles particulares. No carga del servidor
        this.ct= JSON.parse(JSON.stringify(this.schCtrls));

        // defino los botones extra a mostrar
        this.btExtCfg.btnsAccion= this.btExtCfg.btnsAccion.concat([
          { accion: "guardar", icono: "mdi-content-save", show: 1 },
        ]);
          
      },


      async guardar() {
        let p1= this.ct.newPass1[2];
        let p2= this.ct.newPass2[2];
        let error= "";

        if (p1.length< 6 || p2.length< 6) error= 'La nueva contraseña debe tener como mínimo 6 caracteres';
        if (p1!= p2) error= 'La nueva contraseña no coincide';
        if (!p1 || !p2) error= 'Debe indicar una contraseña nueva';
        if (!this.ct.actualPass[2]) error= 'Debe indicar la contraseña actual';

        // muestro mensaje de error si no se han introducido correctamente las contraseñas
        if (error) {
          this.$root.$alert.open(error, 'error', 3000);
          return;
        }


        // call API
        let args = { tipo: 'fnc', accion: 'cambio_pass', fn_args: { 
          app:this.app, 
          pas:this.ct.actualPass[2], 
          new: p1 }};

        let apiResult = await this.$store.dispatch("ajaxRequest", { args: args });
        if (apiResult.sql.error) {
          this.$root.$alert.open(apiResult.sql.msg, 'error');
          return;
        }

        this.$root.$alert.open('Contraseña cambiada correctamente', 'success', 2000);
        
      }

    }
  };
</script>
